import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const memo: CSSObject = {
  padding: '8px 16px 16px',
  fontSize: 14,
  lineHeight: 1.6,
  color: color.text,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
};

const memoEmpty: CSSObject = {
  ...memo,
  color: color.textMuted,
};

const statusButton: CSSObject = {
  width: '100%',
  height: 48,
  marginTop: 12,
};

const item: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  padding: '14px 16px',
  borderBottom: `1px solid ${color.grey75}`,
  fontSize: 14,
  color: color.text,
  ':first-of-type': {
    borderRadius: `${radius.lg}px ${radius.lg}px 0 0`,
  },
  ':last-of-type': {
    borderBottom: 'none',
    borderRadius: `0 0 ${radius.lg}px ${radius.lg}px`,
  },
  ':only-of-type': {
    borderRadius: radius.lg,
  },
  ':active': {
    background: color.grey50,
  },
  p: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  span: {
    flex: 'none',
    fontSize: 13,
    color: color.textMuted,
  },
};

export { memo, memoEmpty, statusButton, item };
